import { createAsyncThunk, createSelector } from '@reduxjs/toolkit';

import { selectLoading } from '../redux/meta/selectors';

export const createAsyncAction = (type, ...args) => {
  const action = createAsyncThunk(type, ...args);
  action.isLoading = createSelector(selectLoading, (loading) => loading[type]);
  return action;
};
